import connect from '../views/axios/axios.auth';

const general = {
  tiposSalidas: () => {
    return new Promise((resolve) => {
      connect.get(`/salidas`).then((tipos) => {
        resolve(tipos.data.tipos);
      })
    })
  },
  listadoClientes: () => {
    return new Promise((resolve) => {
      connect.get(`/cliente/`)
      .then((response) => {
        resolve(response.data.clientes)
      })
    })
  },
  estados: () => {
    return new Promise((resolve) => {
      connect.get(`/utils/estados`)
      .then((response) => {
        resolve(response.data)
      })
    })
  },
  paises: () => {
    return new Promise((resolve) => {
      connect.get(`/utils/paises/`)
      .then((response) => {
        resolve(response.data)
      })
    })
  },
  ciudades: (data) => {
    return new Promise((resolve) => {
      connect.post(`/utils/ciudades`, data)
      .then((response) => {
        resolve(response.data)
      })
    })
  }
}

export default general;